/**
 * Fallback exibido enquanto um chunk lazy está carregando (Suspense).
 * Evita tela preta ao trocar de rota em rede lenta.
 */
export function PageLoader() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-gray-100">
      <div
        className="h-10 w-10 animate-spin rounded-full border-2 border-gray-200 border-t-primary"
        aria-hidden
      />
      <span className="text-sm text-gray-500">Carregando...</span>
    </div>
  );
}

export default PageLoader;
